import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const ScreenListSlice = createSlice({
    name: "ScreenList",
    initialState: {} as IReduxState<any>,
    reducers: {
        getScreenList: (state) => {
            state.isLoading = true;
        },
        successGetScreenList: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureGetScreenList: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearScreenList: (state) => {
            state.data = {};
        },
    },
});

export const {
    getScreenList,
    successGetScreenList,
    failureGetScreenList,
    clearScreenList,
} = ScreenListSlice.actions;

export default ScreenListSlice.reducer;
